// axios
import axios from 'axios'

export default axios.create({
  baseURL : 'https://api.hellodepann.fr/api/v1'
})
